import React from "react";

const CheckoutNavigationItem = ({index, isActive = false, onClick = null, children}: {
  index: number,
  isActive?: boolean,
  onClick?: () => void,
  children: React.ReactNode
}): React.ReactElement =>
  <div onClick={onClick} className={`text-uppercase text-center ${isActive ? "fw-semibold" : ""} ${onClick ? "hoverable" : ""}`}>
    <div className="me-2 px-2 d-inline-block rounded-circle text-center"
          style={{
            backgroundColor: isActive ? "#5082af" : "#edf2f7",
            color: isActive ? "#fff" : "#5082af",
    }}
    >
      {index}
    </div>
    <div>{children}</div>
  </div>;

export default CheckoutNavigationItem;